var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalViewedCouponsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39633 8.36053C1.3399 8.20852 1.3399 8.0413 1.39633 7.88928C1.94591 6.55668 2.87881 5.41728 4.07674 4.61552C5.27468 3.81375 6.6837 3.38574 8.12518 3.38574C9.56666 3.38574 10.9757 3.81375 12.1736 4.61552C13.3715 5.41728 14.3044 6.55668 14.854 7.88928C14.9105 8.0413 14.9105 8.20852 14.854 8.36053C14.3044 9.69313 13.3715 10.8325 12.1736 11.6343C10.9757 12.4361 9.56666 12.8641 8.12518 12.8641C6.6837 12.8641 5.27468 12.4361 4.07674 11.6343C2.87881 10.8325 1.94591 9.69313 1.39633 8.36053Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10.1562C9.24683 10.1562 10.1562 9.24683 10.1562 8.125C10.1562 7.00317 9.24683 6.09375 8.125 6.09375C7.00317 6.09375 6.09375 7.00317 6.09375 8.125C6.09375 9.24683 7.00317 10.1562 8.125 10.1562Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViewedCouponsIcon);
export default __webpack_public_path__ + "static/media/total-viewed-coupons-icon.cad35fc6ddd3cf266be221f52937aed4.svg";
export { ForwardRef as ReactComponent };